module.exports = __webpack_public_path__ + "static/tyson-59e86b5a53c2cb961ab4ed595adc5c07.png";